import React from "react";
import "./ContactSection.css";

const ContactSection = () => {
  return (
    <section className="section" id="contact">
      <div className="container">
        <h2 className="section-title">Contact</h2>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <svg className="contact-icon" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
              <a href="mailto:contact@abbottmusicstudio.com">
                contact@abbottmusicstudio.com
              </a>
            </div>

            <div className="contact-item">
              <svg className="contact-icon" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
              </svg>
              <a href="tel:+923000000000">+92 348 3335274</a>
            </div>

            <div className="contact-item">
              <svg className="contact-icon" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span>Abbottabad, Pakistan</span>
            </div>

            <div className="contact-item">
              <svg className="contact-icon" fill="currentColor" viewBox="0 0 20 20">
                <path d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z"></path>
                <path d="M9 8a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
              </svg>
              <a
                href="/brochure.pdf"
                download="Abbott-Music-Studio-Brochure.pdf"
                className="download-brochure"
              >
                Download Our Brochure
              </a>
            </div>

            <div className="contact-buttons">
              <a href="mailto:contact@abbottmusicstudio.com" className="btn-primary">
                Email Us
              </a>
            </div>
          </div>

          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4195.541743608699!2d73.20885327652668!3d34.161436373116054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38de310016cda851%3A0xd14675bc22662e21!2sAbbott%20Music%20Studio%20Abbottabad!5e1!3m2!1sen!2s!4v1755803241612!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Abbott Music Studio Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
